var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "evi-chain-root-sty" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "chain-content-sty" },
      [
        [
          _vm._m(1),
          _c("div", { staticClass: "info-sty" }, [
            _c("p", [
              _c("span", [_vm._v("主题名称")]),
              _c("span", { staticClass: "font-bolder font-red" }, [
                _vm._v(_vm._s(_vm.contractInfo.contractName))
              ])
            ]),
            _c("p", [
              _c("span", [_vm._v("签约编号")]),
              _c("span", { staticClass: "font-red" }, [
                _vm._v(_vm._s(_vm.contractInfo.applyNo))
              ])
            ]),
            _c("p", [
              _c("span", [_vm._v("文件名称")]),
              _c("span", [_vm._v(_vm._s(_vm.contractInfo.contractName))])
            ]),
            _c("p", [
              _c("span", [_vm._v("发起时间")]),
              _c("span", [
                _vm._v(
                  _vm._s(_vm._f("formatDateTime")(_vm.contractInfo.createTime))
                )
              ])
            ]),
            _c("p", [
              _c("span", [_vm._v("文件来源")]),
              _c("span", [_vm._v(_vm._s(_vm.contractInfo.ebqUserName))])
            ]),
            _c("p", [
              _c("span", [_vm._v("创建方式")]),
              _c("span", [
                _vm._v(_vm._s(_vm.contractInfo.createType == 1 ? "WEB" : "API"))
              ])
            ])
          ])
        ],
        [
          _vm._m(2),
          _vm._l(
            _vm.applySignRecord.filter(function(v) {
              return [14].includes(v.signType)
            }),
            function(item) {
              return _c("div", { key: item.id, staticClass: "info-sty" }, [
                _c("p", [
                  _c("span", [_vm._v("名称")]),
                  _c("span", { staticClass: "font-bolder font-red" }, [
                    _vm._v(_vm._s(item.name))
                  ])
                ]),
                _c("p", [
                  _c("span", [_vm._v("证件号")]),
                  _c("span", { staticClass: "font-red" }, [
                    _vm._v(_vm._s(item.identityCard))
                  ])
                ]),
                _c("p", [
                  _c("span", [_vm._v("终端ip")]),
                  _c("span", [_vm._v(_vm._s(item.ip))])
                ]),
                _c("p", [
                  _c("span", [_vm._v("发起时间")]),
                  _c("span", [_vm._v(_vm._s(item.createTime))])
                ]),
                _c(
                  "p",
                  {
                    staticStyle: {
                      width: "100%",
                      "white-space": "normal",
                      "word-break": "break-all"
                    }
                  },
                  [
                    _c("span", [_vm._v("地址")]),
                    _c("span", [_vm._v(_vm._s(item.url))])
                  ]
                )
              ])
            }
          )
        ],
        _vm.signtorList.length
          ? [
              _vm._m(3),
              _c(
                "div",
                { staticClass: "signatory-sty" },
                _vm._l(_vm.signtorList, function(sign) {
                  return _c(
                    "div",
                    { key: sign.id, staticClass: "signatory-item-sty" },
                    [
                      _c("div", { staticClass: "type-header-sty" }, [
                        _c(
                          "div",
                          {
                            staticClass: "type-icon-sty",
                            class: [
                              sign.userType && sign.userType == 1
                                ? "ent-sty"
                                : "person-sty"
                            ]
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  sign.userType && sign.userType == 1
                                    ? "企业"
                                    : "个人"
                                ) +
                                "\n            "
                            )
                          ]
                        ),
                        _c("div", [
                          _c("p", [_vm._v(_vm._s(sign.name))]),
                          _c("p", [
                            _vm._v("证件号：" + _vm._s(sign.identityCard))
                          ])
                        ])
                      ]),
                      _vm.registShow(sign).length > 0
                        ? [
                            _c("p", { staticClass: "title-ii-sty" }, [
                              _vm._v("注册认证信息")
                            ]),
                            _vm._l(_vm.registShow(sign), function(reco, i) {
                              return _c(
                                "div",
                                { key: i, staticClass: "sign-info-sty" },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c("el-col", { attrs: { span: 6 } }, [
                                        _vm._v("认证方式")
                                      ]),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "font-bolder font-red",
                                          attrs: { span: 18 }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.fluStatus(
                                                reco.authType,
                                                reco.userType
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    [
                                      _c("el-col", { attrs: { span: 6 } }, [
                                        _vm._v("认证时间")
                                      ]),
                                      _c("el-col", { attrs: { span: 18 } }, [
                                        _vm._v(_vm._s(reco.authDate))
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    [
                                      _c("el-col", { attrs: { span: 6 } }, [
                                        _vm._v("流水号")
                                      ]),
                                      _c(
                                        "el-col",
                                        {
                                          staticStyle: { color: "#e76177" },
                                          attrs: { span: 18 }
                                        },
                                        [_vm._v(_vm._s(reco.orderNo))]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    [
                                      _c("el-col", { attrs: { span: 6 } }, [
                                        _vm._v("认证结果")
                                      ]),
                                      _c("el-col", { attrs: { span: 18 } }, [
                                        _c(
                                          "span",
                                          { staticClass: "auth-res-sty" },
                                          [
                                            reco.authType == 1 && reco.context
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      "匹配百分比：" +
                                                        parseFloat(
                                                          reco.context
                                                        ).toFixed(2) +
                                                        "%，"
                                                    )
                                                  )
                                                ])
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              { staticClass: "auth-statu-sty" },
                                              [_vm._v("认证通过")]
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            })
                          ]
                        : _c("el-empty", {
                            attrs: {
                              description: "暂无注册认证信息",
                              "image-size": 40
                            }
                          })
                    ],
                    2
                  )
                }),
                0
              )
            ]
          : _vm._e(),
        _vm.signatoryNotifys.length
          ? [
              _vm._m(4),
              _c(
                "el-timeline",
                _vm._l(_vm.signatoryNotifys, function(item, i) {
                  return _c(
                    "el-timeline-item",
                    { key: i },
                    [
                      _c("template", { slot: "dot" }, [
                        _c("i", { staticClass: "dot-sty" })
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "signing-process-sty",
                          class: item.className
                        },
                        [
                          _c(
                            "el-row",
                            {
                              staticClass: "signing-header-sty header-type-sty"
                            },
                            [
                              _c(
                                "el-col",
                                {
                                  staticStyle: { "text-align": "center" },
                                  attrs: { span: 4 }
                                },
                                [
                                  _c("span", { staticClass: "header-title" }, [
                                    _vm._v(_vm._s(item.label))
                                  ])
                                ]
                              ),
                              _c("el-col", { attrs: { span: 14 } }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          item.signType !== 24 && item.name,
                                        expression:
                                          "item.signType !== 24 && item.name"
                                      }
                                    ],
                                    staticClass: "font-bolder"
                                  },
                                  [_vm._v(_vm._s(item.name))]
                                ),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          item.signType !== 24 &&
                                          item.identityCard,
                                        expression:
                                          "item.signType !== 24 && item.identityCard"
                                      }
                                    ],
                                    staticClass: "card-num-sty"
                                  },
                                  [_vm._v(_vm._s(item.identityCard))]
                                )
                              ]),
                              _c(
                                "el-col",
                                {
                                  staticStyle: {
                                    "text-align": "right",
                                    "font-weight": "bolder",
                                    "padding-right": "20px"
                                  },
                                  attrs: { span: 6 }
                                },
                                [_vm._v(_vm._s(item.createTime))]
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "sign-content-sty" },
                            [
                              item.signType == 14
                                ? [
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("创建时间")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.createTime))
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("终端IP")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.ip))
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("地址")
                                        ]),
                                        _c(
                                          "el-col",
                                          {
                                            staticStyle: {
                                              "white-space": "normal",
                                              "word-break": "break-all"
                                            },
                                            attrs: { span: 20 }
                                          },
                                          [_vm._v(_vm._s(item.url))]
                                        )
                                      ],
                                      1
                                    ),
                                    item.readTimeSignInfoList &&
                                    item.readTimeSignInfoList.length
                                      ? _vm._l(
                                          item.readTimeSignInfoList,
                                          function(childItem, childIndex) {
                                            return _c(
                                              "el-row",
                                              { key: "xxx" + childIndex },
                                              [
                                                _c("el-col", {
                                                  attrs: { span: 4 }
                                                }),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 20 } },
                                                  [
                                                    _vm._v(
                                                      "发起方给签署方（" +
                                                        _vm._s(childItem.name) +
                                                        "）设置了" +
                                                        _vm._s(
                                                          childItem.readTime
                                                        ) +
                                                        "s强制阅读"
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        )
                                      : _vm._e(),
                                    item.signingTipsList &&
                                    item.signingTipsList.length
                                      ? _vm._l(item.signingTipsList, function(
                                          sign,
                                          i
                                        ) {
                                          return _c(
                                            "div",
                                            { key: i },
                                            [
                                              sign.signatoryFullName
                                                ? _c(
                                                    "el-row",
                                                    [
                                                      _c("el-col", {
                                                        attrs: { span: 4 }
                                                      }),
                                                      _c(
                                                        "el-col",
                                                        { attrs: { span: 20 } },
                                                        [
                                                          _vm._v(
                                                            "指定签署方（" +
                                                              _vm._s(
                                                                sign.signatoryFullName
                                                              ) +
                                                              "）阅读并确认。"
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              sign.signingTipsTitle
                                                ? _c(
                                                    "el-row",
                                                    [
                                                      _c(
                                                        "el-col",
                                                        { attrs: { span: 4 } },
                                                        [_vm._v("签署提示标题")]
                                                      ),
                                                      _c(
                                                        "el-col",
                                                        { attrs: { span: 20 } },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              sign.signingTipsTitle
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              sign.signingTipsContent
                                                ? _c(
                                                    "el-row",
                                                    [
                                                      _c(
                                                        "el-col",
                                                        { attrs: { span: 4 } },
                                                        [_vm._v("已阅读并确认")]
                                                      ),
                                                      _c(
                                                        "el-col",
                                                        { attrs: { span: 20 } },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              sign.signingTipsContent
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        })
                                      : _vm._e()
                                  ]
                                : _vm._e(),
                              item.signType == 1
                                ? [
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("操作")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v("登录签约中心")
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("终端IP")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.ip))
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("签约地址")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.url))
                                        ])
                                      ],
                                      1
                                    ),
                                    item.userAgent && item.userAgent != ""
                                      ? _c(
                                          "el-row",
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 4 } },
                                              [_vm._v("浏览器UA")]
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 20 } },
                                              [_vm._v(_vm._s(item.userAgent))]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    item.addr
                                      ? _c(
                                          "el-row",
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 4 } },
                                              [_vm._v("地理位置")]
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 20 } },
                                              [_vm._v(_vm._s(item.addr))]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                : _vm._e(),
                              item.signType == 4
                                ? [
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("CA证书序列号")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.signRefcode))
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("CA有效期")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(
                                            _vm._s(item.signStartTime) +
                                              " 至 " +
                                              _vm._s(item.signExpireTime)
                                          )
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("签署文件")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(
                                            _vm._s(
                                              item.contractNames &&
                                                item.contractNames.length
                                                ? item.contractNames.join(",")
                                                : _vm.contractInfo.contractName
                                            )
                                          )
                                        ])
                                      ],
                                      1
                                    ),
                                    item.signingTipsContent
                                      ? _c(
                                          "el-row",
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 4 } },
                                              [_vm._v("已阅读并确认")]
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 20 } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.signingTipsContent
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("存证说明")
                                        ]),
                                        _c(
                                          "el-col",
                                          {
                                            staticClass: "font-red",
                                            attrs: { span: 20 }
                                          },
                                          [
                                            _vm._v(
                                              "系统已自动将签署证据提交至第三方机构（保全中心、公证处、司法鉴定中心等）"
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                : _vm._e(),
                              item.signType == 5
                                ? [
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("时间")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.createTime))
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("拒签理由")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.context))
                                        ])
                                      ],
                                      1
                                    ),
                                    item.addr
                                      ? _c(
                                          "el-row",
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 4 } },
                                              [_vm._v("地理位置")]
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 20 } },
                                              [_vm._v(_vm._s(item.addr))]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                : _vm._e(),
                              item.signType == 7
                                ? [
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("时间")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.createTime))
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(
                                            "删除" +
                                              _vm._s(item.fileName) +
                                              "成功，Hash值：" +
                                              _vm._s(item.docHash)
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                : item.signType == 9
                                ? [
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("时间")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.createTime))
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.context))
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                : _vm._e(),
                              [2, 3, 10, 15, 19, 21, 22, 25, 26].includes(
                                item.signType
                              )
                                ? [
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("认证方式")
                                        ]),
                                        _c(
                                          "el-col",
                                          {
                                            staticClass: "font-red font-bolder",
                                            attrs: { span: 20 }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  item.signType == 26
                                                    ? item.bank
                                                    : _vm.authTypeList[
                                                        item.signType
                                                      ]
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("认证时间")
                                        ]),
                                        [
                                          item.signType == 25
                                            ? _c(
                                                "el-col",
                                                { attrs: { span: 20 } },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.aiAuthTime)
                                                  )
                                                ]
                                              )
                                            : item.signType == 26
                                            ? _c(
                                                "el-col",
                                                { attrs: { span: 20 } },
                                                [_vm._v(_vm._s(item.asrTime))]
                                              )
                                            : _c(
                                                "el-col",
                                                { attrs: { span: 20 } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      !item.faceTime
                                                        ? item.createTime
                                                        : item.faceTime
                                                    )
                                                  )
                                                ]
                                              )
                                        ]
                                      ],
                                      2
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("流水号")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.orderNo))
                                        ])
                                      ],
                                      1
                                    ),
                                    [
                                      item.signType == 10
                                        ? [
                                            item.faceAuthName &&
                                            item.faceAuthIdNo
                                              ? _c(
                                                  "el-row",
                                                  [
                                                    _c(
                                                      "el-col",
                                                      { attrs: { span: 4 } },
                                                      [_vm._v("授权人")]
                                                    ),
                                                    _c(
                                                      "el-col",
                                                      { attrs: { span: 20 } },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.faceAuthName
                                                          ) +
                                                            "(" +
                                                            _vm._s(
                                                              item.faceAuthIdNo
                                                            ) +
                                                            ")"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            item.docHash
                                              ? _c(
                                                  "el-row",
                                                  [
                                                    _c("el-col", {
                                                      attrs: { span: 4 }
                                                    }),
                                                    _c(
                                                      "el-col",
                                                      { attrs: { span: 20 } },
                                                      [
                                                        _vm._v(
                                                          "\n                        人脸识别视频存证成功,Hash值:" +
                                                            _vm._s(
                                                              item.docHash
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ]
                                        : _vm._e(),
                                      item.mobile || item.cardNo
                                        ? _c(
                                            "el-row",
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 4 } },
                                                [_vm._v("认证信息")]
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 20 } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.mobile || item.cardNo
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      item.signType == 26
                                        ? [
                                            _c(
                                              "el-row",
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 4 } },
                                                  [_vm._v("语义是否一致")]
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 20 } },
                                                  [_vm._v("是")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        : _vm._e()
                                    ],
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("认证结果")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _c(
                                            "span",
                                            { staticClass: "auth-res-sty" },
                                            [
                                              item.context
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        "匹配百分比：" +
                                                          parseFloat(
                                                            item.context
                                                          ).toFixed(2) +
                                                          "%，"
                                                      )
                                                    )
                                                  ])
                                                : _vm._e(),
                                              item.similarity
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        (item.signType == 25
                                                          ? "人脸识别相似度"
                                                          : "相似度") +
                                                          "：" +
                                                          parseFloat(
                                                            item.similarity
                                                          ).toFixed(2) +
                                                          "%，"
                                                      )
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "auth-statu-sty"
                                                },
                                                [_vm._v("认证通过")]
                                              )
                                            ]
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                : _vm._e(),
                              item.signType == 11
                                ? [
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("材料名称：")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.fileName))
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("Hash值：")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.docHash))
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                : _vm._e(),
                              item.signType == 12
                                ? [
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("时间")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.createTime))
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.context))
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                : _vm._e(),
                              item.signType == 13
                                ? [
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("时间")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.createTime))
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(
                                            "本次签署为连续签署，上一份签署【" +
                                              _vm._s(item.context) +
                                              "】已完成签署并记录签署日志\n                    （连续签署必须按照顺序依次连续完成签署，不可中途中断签署或跳过第一份文件进行签署，\n                    身份验证适用于每一份连续签署）。"
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                : _vm._e(),
                              +item.signType === 16
                                ? [
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("时间")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.createTime))
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("终端IP")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.ip))
                                        ])
                                      ],
                                      1
                                    ),
                                    item.userAgent && item.userAgent != ""
                                      ? _c(
                                          "el-row",
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 4 } },
                                              [_vm._v("浏览器UA")]
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 20 } },
                                              [_vm._v(_vm._s(item.userAgent))]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    item.addr
                                      ? _c(
                                          "el-row",
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 4 } },
                                              [_vm._v("地理位置")]
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 20 } },
                                              [_vm._v(_vm._s(item.addr))]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                : _vm._e(),
                              item.signType == 17
                                ? [
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("时间")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.createTime))
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("编号")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getId(item.safeKeepLetterId)
                                            )
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                : _vm._e(),
                              item.signType == 18
                                ? [
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("时间")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.createTime))
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("终端IP")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.ip))
                                        ])
                                      ],
                                      1
                                    ),
                                    item.addr
                                      ? _c(
                                          "el-row",
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 4 } },
                                              [_vm._v("地理位置")]
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 20 } },
                                              [_vm._v(_vm._s(item.addr))]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    item.signingTipsContent
                                      ? _c(
                                          "el-row",
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 4 } },
                                              [_vm._v("已阅读并确认")]
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 20 } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.signingTipsContent
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.name) + "确认签署")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                : _vm._e(),
                              item.signType == 20
                                ? [
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("时间")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.createTime))
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("通知短信")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.mobile))
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                : _vm._e(),
                              item.signType === 24
                                ? [
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("发送方名称")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.name))
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("发送方证件号")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.identityCard))
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("通知发送时间")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(_vm._s(item.createTime))
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("接收方名称")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(
                                            _vm._s(
                                              item.notify[0]
                                                ? item.notify[0].name
                                                : ""
                                            )
                                          )
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("接收方证件号")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(
                                            _vm._s(
                                              item.notify[0]
                                                ? item.notify[0].idNo
                                                : ""
                                            )
                                          )
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 4 } }, [
                                          _vm._v("接收方号码")
                                        ]),
                                        _c("el-col", { attrs: { span: 20 } }, [
                                          _vm._v(
                                            _vm._s(
                                              item.notify[0]
                                                ? item.notify[0].target
                                                : ""
                                            )
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                }),
                1
              )
            ]
          : _vm._e(),
        _vm.finalEviList.length
          ? [
              _vm._m(5),
              _c(
                "el-timeline",
                _vm._l(_vm.finalEviList, function(evid, i) {
                  return _c(
                    "el-timeline-item",
                    { key: i },
                    [
                      _c("template", { slot: "dot" }, [
                        _c("i", { staticClass: "dot-sty" })
                      ]),
                      _c(
                        "div",
                        { staticClass: "signing-process-sty signing-evi-sty" },
                        [
                          _c(
                            "el-row",
                            {
                              staticClass: "signing-header-sty header-type-sty"
                            },
                            [
                              _c(
                                "el-col",
                                {
                                  staticStyle: { "text-align": "center" },
                                  attrs: { span: 4 }
                                },
                                [
                                  _c("span", { staticClass: "header-title" }, [
                                    _vm._v(_vm._s(evid.storeType))
                                  ])
                                ]
                              ),
                              _c("el-col", { attrs: { span: 14 } }, [
                                _c("span", { staticClass: "font-bolder" }, [
                                  _vm._v(_vm._s(evid.name))
                                ]),
                                _c("span", { staticClass: "card-num-sty" }, [
                                  _vm._v(_vm._s(evid.identityCard))
                                ])
                              ]),
                              _c(
                                "el-col",
                                {
                                  staticStyle: {
                                    "text-align": "right",
                                    "font-weight": "bolder",
                                    "padding-right": "20px"
                                  },
                                  attrs: { span: 6 }
                                },
                                [_vm._v(_vm._s(evid.createTime))]
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "sign-content-sty" },
                            [
                              _c(
                                "el-row",
                                [
                                  _c("el-col", { attrs: { span: 4 } }, [
                                    _vm._v(
                                      _vm._s(
                                        evid.themeName ? "签约主题" : "文件名称"
                                      )
                                    )
                                  ]),
                                  _c("el-col", { attrs: { span: 20 } }, [
                                    _vm._v(
                                      _vm._s(
                                        evid.themeName
                                          ? evid.themeName
                                          : evid.contractNames &&
                                            evid.contractNames.length
                                          ? evid.contractNames.join(",")
                                          : _vm.contractInfo.contractName
                                      )
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("el-col", { attrs: { span: 4 } }, [
                                    _vm._v("备案号")
                                  ]),
                                  _c("el-col", { attrs: { span: 20 } }, [
                                    _vm._v(_vm._s(evid.presId))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                }),
                1
              )
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "chain-header" }, [
      _c("img", {
        staticClass: "logo-img-sty",
        attrs: { src: "/images/logo/u123.png", alt: "君子签" }
      }),
      _c("h1", [_vm._v("电子签约全证据链")]),
      _c("h2", [_vm._v("FULL EVIDENCE CHAIN OF ELECTRONIC CONTRACTING")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "tip-title-sty" }, [
      _c("span", { staticClass: "tip-icon" }),
      _c("span", { staticClass: "title-sty" }, [_vm._v("文件信息")]),
      _c("span", { staticClass: "line" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "tip-title-sty" }, [
      _c("span", { staticClass: "tip-icon" }),
      _c("span", { staticClass: "title-sty" }, [_vm._v("发起方信息")]),
      _c("span", { staticClass: "line" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "tip-title-sty" }, [
      _c("span", { staticClass: "tip-icon" }),
      _c("span", { staticClass: "title-sty" }, [_vm._v("签署方信息")]),
      _c("span", { staticClass: "line" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "tip-title-sty" }, [
      _c("span", { staticClass: "tip-icon" }),
      _c("span", { staticClass: "title-sty" }, [_vm._v("签署流程时间线")]),
      _c("span", { staticClass: "line" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "tip-title-sty" }, [
      _c("span", { staticClass: "tip-icon" }),
      _c("span", { staticClass: "title-sty" }, [_vm._v("最终存证")]),
      _c("span", { staticClass: "line" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08bf282e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08bf282e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/applySign/fullEvidenceChain.vue
// module id = 6D/L
// module chunks = 112